module.exports = function() {
  return new Worker(__webpack_public_path__ + "b84bb0aa10d5f30fe300.worker.js");
};